import yoda from '@kibt/bridge';
import { radar } from '@/common/log';

export interface KSwitchKeyType {
    key: string;
}

export async function getKSwitch(keys: KSwitchKeyType[]): Promise<
    Array<{
        key: string;
        value: any;
    }>
> {
    console.log('switch keys =>', keys);
    try {
        const switchData = await yoda.tool.getKswitchData({
            keys,
        });
        const { data } = switchData || { data: [] };
        radar.event({ name: 'Shop_C_RN_SWITCH_Res', params: { res: data } });
        if (Array.isArray(data)) {
            return data;
        }
        return [];
    } catch (e) {
        console.log('getKSwitch Eroor', e);
        return [];
    }
}
